/* eslint-disable complexity */
import { QB_OPERATOR_TYPES } from '../helpers/types.js';

const conditionSql = (condition, value) => {
  const {
    EQUAL,
    NOT_EQUAL,
    GREATER_THAN,
    LESS_THAN,
    CONTAINS,
    NOT_CONTAINS,
    BETWEEN,
    GREATER_THAN_OR_EQUAL,
    LESS_THAN_OR_EQUAL,
    START_WITH,
  } = QB_OPERATOR_TYPES;

  if (condition === EQUAL) return ` = '${value}'`;
  if (condition === NOT_EQUAL) return ` <> '${value}'`;
  if (condition === GREATER_THAN) return ` > ${value}`;
  if (condition === LESS_THAN) return ` < ${value}`;
  if (condition === CONTAINS) return ` LIKE '%${value}%'`;
  if (condition === NOT_CONTAINS) return ` NOT LIKE '%${value}%'`;
  if (condition === BETWEEN) return ` BETWEEN ${value[0]} AND ${value[1]} `;
  if (condition === GREATER_THAN_OR_EQUAL) return ` >= ${value}`;
  if (condition === LESS_THAN_OR_EQUAL) return ` <= ${value}`;
  if (condition === START_WITH) return ` LIKE '${value}%'`;
  if (condition === 'NOT_START_WITH') return ` NOT LIKE '${value}%'`;
  return condition;
};

const renderFilterSQl = (filter) => {
  const { field, operator, value } = filter.element;

  return `${field} ${conditionSql(operator, value) || ''}`;
};
export const sqlFormat = ({ main, mapGroups, items }) => {
  const groupSql = (item, idGroup) => {
    if (idGroup === main) {
      const groupCondition = mapGroups[idGroup].condition === true ? 'AND' : 'OR';
      return ` ( ${filterSql(item, groupCondition)} ) `; // eslint-disable-line
    }
    const groupCondition = item.element.condition === true ? 'AND' : 'OR';
    return ` ( ${filterSql(item.children, groupCondition)} ) `; // eslint-disable-line
  };

  const filterSql = (filters, groupCondition) => {
    const filterGroup = filters.map((filter) => {
      if (filter.element.type === 'filter') return ` ${renderFilterSQl(filter)} `;
      return ` ${groupSql(filter) || ''} `;
    });
    return filterGroup.join(groupCondition);
  };

  const sql = ` FROM [TABLE_NAME] WHERE ${groupSql(items, main) || ''} `;

  return sql;
};
